import Vuex from "vuex";
import Vue from "vue";
import api from "../../axios/api";
import { DataTypeList } from "@/axios/service/travel.js";

Vue.use(Vuex);
const WriteDataStore = {
  namespaced: true,
  state: {
    returnTopBottomValue: "",
    playWayList: [], //
    travelAttributeData: {},
    writeData: {}, //已经编写的form数据(预览)
    formData: {}, //由pre页和write页合并的form数据
    backData: {}
  },
  mutations: {
    bottomMutation(state, value) {
      state.returnTopBottomValue = value;
    },
    getFun(state, value) {
      state.playWayList = value;
    },
    travelAttributeData(state, value) {
      state.writeData = value;
    },
    //预览数据
    writeDataMutation(state, value) {
      state.writeData = value;
    },
    //合并数据
    mergeData(state, value) {
      state.formData = {
        ...state.writeData
      };
    },
    back(state, value) {
      state.backData = value;
    }
  },
  actions: {
    getDataTypeList(context, params) {
      let param = params || {
        type: 0
      };

      DataTypeList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          const getList = (data, dataTypeList) => {
            if (param.type === 0) {
              data.forEach(element => {
                if (element.code === 2) {
                  //只留游玩选项
                  dataTypeList.push({
                    label: element.name,
                    value: element.code
                  });
                }
              });
            } else {
              data.forEach(element => {
                dataTypeList.push({
                  label: element.name,
                  value: element.code
                });
              });
            }
            return dataTypeList;
          };

          context.commit("getFun", getList(json.data, []));
        } else {
          context.commit("getFun", []);
        }
      });
    }
  }
};

export default WriteDataStore;
